module.exports = __webpack_public_path__ + "static/media/doorClosing.2062ad98.mp3";